/**
 *
 * @author: Matthew Rawson @ 12/09/2017 13:11
 * @description:
 * @notes:
 */
import styled from "styled-components"
import {minWidthMedia} from "@irati/ui/src/global/media"

export default styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  ${minWidthMedia.tablet`
    flex-direction: row;
  `}
`
